
import Vue from 'vue'
import dayjs from '@app/js/lib/dayjs'
import _ from 'underscore'

const categorys = {
  1: '加入购物车',
  2: '立即购买',
  3: '搜索',
}

const getParams = (value) => {
  const serviceParam = {}

  let data = value.data
  if (data.p) {
    for (const p of data.p) {
      let px = `p${Object.keys(serviceParam).length + 1}`
      serviceParam[px] = `${p}`
    }
  }

  const params = {
    category: categorys[data.id],
    action: value.act,
    opt_label: JSON.stringify(serviceParam)
  }
  return params
}
// 生成随机函数属性名
const createFunName = () => {
  return `track_f_${(Math.random() * 1000000 + '').split('.')[0]}`
}

// 点击处理函数
const clickFun = (el, binding) => {
  const params = getParams(binding.value)
  tracker(params)
  el.removeEventListener('click', FunCollection[el.dataset.clickFun])
}

const tracker = ({category, action, opt_label, opt_value = ""}) => {
  // console.log("======")
  // console.log({category, action, opt_label, opt_value})
  // console.log("======", _hmt)
  _hmt.push(['_trackEvent', category, action, opt_label, opt_value]);
}

// 已绑定的事件处理函数集合
const FunCollection = {}
// 埋点事件逻辑
const track = (el, binding, forceRun = false) => {
  const type = binding.value.act
  if (type === 'click') {
    const cf = el.dataset.clickFun
    if (cf && FunCollection[cf]) {
      el.removeEventListener('click', FunCollection[cf])
      delete FunCollection[cf]
    }
    const fs = createFunName()
    FunCollection[fs] = clickFun.bind(null, el, binding)
    el.dataset.clickFun = fs
    el.addEventListener('click', FunCollection[fs])
  }
}

Vue.directive('track-baidu', {
  bind: function (el, binding) {
    el.dataset.enterTime = dayjs().valueOf()
    if((typeof binding.value.t === 'undefined') || binding.value.t === 'bind') {
      track(el, binding)
    }
  },
  update: function (el, binding) {
    if(binding.value.t === 'update' || binding.value.act === 'unload') {
      track(el, binding)
    }
  },
  unbind: function (el, binding) {
    el.dataset.leaveTime = dayjs().valueOf()
    // 移除未触发的事件
    const type = binding.value.act
    if (type === 'click') {
      const cf = el.dataset.clickFun
      if (cf && FunCollection[cf]) {
        el.removeEventListener('click', FunCollection[cf])
        delete FunCollection[cf]
      }
    }
  }
})
// 订单数据
const trackOrder = (orderInfo) => {
  _hmt.push(['_trackOrder', orderInfo]);
}
// 事件跟踪
const trackEvent = (value) => {
  const params = getParams(value)
  tracker(params)
}

export default {
  trackOrder,
  trackEvent
}